import React, { Component } from "react";

class LoadingSpinner extends Component {
  render() {
    return (
      <div className="spinner-container">
        <div className="loading-spinner"></div>
      </div>
    );
  }
}

export default LoadingSpinner;
